export const setRefreshState = ({commit}, data) => {
  commit("setRefreshState", data);  // 这里的变量名需与mutations中保持一致
}
